import EventManager from '../eventManager/EventManager'
import { Clock } from '../helpers/Clock'
import { getQueryParam } from '../helpers/getQueryParam'
import WebModel from '../models/WebModel'
import { MetricsLocalClient } from './MetricsLocalClient'
import { MetricsNewRelicClient } from './MetricsNewRelicClient'

/* eslint-disable no-magic-numbers */
const TIME_TRACKING_INTERVALS = [
  5 * 1000,
  10 * 1000,
  15 * 1000,
  30 * 1000,
  45 * 1000,
  90 * 1000
]

const ONE_MINUTE = 60 * 1000
const TEN_MINUTES = 600 * 1000

export default class MetricsTracker {
  clients: Array<IMetricsClient>

  constructor(readonly model: WebModel) {
    Object.keys(EventManager.events).forEach((k) => {
      const event = EventManager.events[k]
      EventManager.on(event, (v) => this.record(event, v))
    })

    this.clients = [new MetricsLocalClient()]

    if (forceMetrics()) {
      this.clients = [
        new MetricsLocalClient(),
        new MetricsNewRelicClient(model)
      ]
    } else if (!skipSample(model.samplingRate)) {
      this.clients = [
        new MetricsLocalClient(),
        new MetricsNewRelicClient(model)
      ]
    }

    this.trackTimeMetrics()
  }

  record(event, data): void {
    this.clients.forEach((c) => {
      try {
        c.record(event, data)
      } catch (e) {
        /* noop */
      }
    })
  }

  private trackTimeMetrics(): void {
    this.record('newRelicLoaded', { time_elapsed: Clock.getTime() })
    // Record every minute
    let minutes = 0
    const interval = setInterval(() => {
      minutes++
      this.record('timeOnSite', { time_elapsed: minutes * 60 })
    }, ONE_MINUTE)
    // Record additional intervals
    TIME_TRACKING_INTERVALS.forEach((time) =>
      setTimeout(
        () => this.record('timeOnSite', { time_elapsed: time / 1000 }),
        time
      )
    )
    // Remove the minute tracking after 10 minutes
    setTimeout(() => clearInterval(interval), TEN_MINUTES)
  }
}

export interface IMetricsClient {
  record(eventName: string, data: object): void
}

export function forceMetrics(): boolean {
  return !!getQueryParam('forceMetrics')
}

export function skipSample(sampleRate: number | undefined): boolean {
  return !sampleRate || sampleRate < Math.random()
}
